import React from 'react';
import { gql } from '@apollo/client';
import { Show } from 'react-admin';
import RateSettingsShow from '../shared/rate-settings-show/RateSettingsShow';

const LocationRateSettingShow = () => (
  <Show>
    <RateSettingsShow />
  </Show>
);

LocationRateSettingShow.query = gql`
  query locationRateSetting($id: Int!) {
    locationRateSetting(id: $id, include_parents: true) {
      id
      active
      location {
        state {
          name
        }
        created_at
        primary_billing_group {
          plan
        }
      }
      location_id
      location {
        id
        name
      }
      settings
      location_rate_setting
      updated_at
    }
  }
`;

export default LocationRateSettingShow;
